<template>
  <!-- 登入頁 -->
  <app-logo-page-container>
    <v-flex xs10 sm6 md3>
      <v-form
        class="signin-form mt-2"
        ref="form"
        v-model="valid"
        @submit.prevent>

          <!-- :rules="usernameRules" -->
        <v-text-field
          v-model="username"
          autocomplete="username"
          :rules="usernameRules"
          :hint="usernameHint"
          prepend-icon="person"
          label="帳號"
          color="black"
          @keyup.enter="submit"
          persistent-hint
          validate-on-blur />

        <v-text-field
          class="mt-4"
          v-model="pwd"
          autocomplete="current-password"
          :rules="pwdRules"
          :type="showPwd ? 'text' : 'password'"
          @click:append="showPwd = !showPwd"
          prepend-icon="lock"
          label="密碼"
          color="black"
          @keyup.enter="submit"
          validate-on-blur />

        <div class="mt-4 d-flex align-center">
          <v-btn
            class="mr-2 white--text"
            color="pink"
            :loading="loading"
            @click="submit"
            block>
            登入
          </v-btn>

          <v-btn
            color="pink"
            @click="$router.push({name: 'ForgetPassword'})"
            flat
            block>
            忘記密碼?
          </v-btn>
        </div>

        <v-alert
          class="mt-4"
          v-show="errMsg"
          transition="slide-y-transition"
          :value="true"
          type="error">
          {{errMsg}}
        </v-alert>

        <v-btn
          class="mt-4"
          color="pink"
          @click="$router.push({name: 'Signup'})"
          outline
          block>
          註冊
        </v-btn>
      </v-form>
    </v-flex>
  </app-logo-page-container>
</template>

<script>
import {mapActions} from 'vuex';
import {username, pwd} from '@/validate-rules';

export default {
  data() {
    return {
      valid: true,
      loading: false,
      errMsg: null,
      showPwd: false,
      username: '',
      usernameHint: username.hint,
      usernameRules: username.rules(),
      pwd: '',
      pwdRules: pwd.rules()
    };
  },

  watch: {
    username() {
      this.username = this.username.toLowerCase();
    }
  },

  mounted() {},

  methods: {
    ...mapActions(['signin']),

    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.errMsg = null;
      this.loading = true;
      try {
        await this.signin({username: this.username, password: this.pwd});
      } catch (e) {
        this.errMsg = e.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>
